// window.addEventListener('load', () => {
//     document.body.style.transition = 'opacity 0.5s';
//     document.body.style.opacity = '1';
// });

// Sidebar Drawer Script
document.addEventListener('DOMContentLoaded', function() {
  // Elements
  const html = document.documentElement;
  const openSidebarBtn = document.querySelector('.sidebar-label');
  const drawer = document.getElementById('shopify-section-sidebar-filter');
  const closeIcon = document.querySelector('.close-sidebar')
  const overlay = document.createElement('div');
  
  // Create overlay element for detecting outside clicks
  overlay.classList.add('drawer-overlay');
  document.body.appendChild(overlay);
  
  function openDrawer() {
    html.classList.add('sidebar-open');
    document.body.style.overflow = 'hidden'; // Prevent scrolling
  }
  
  function closeDrawer() {
    html.classList.remove('sidebar-open');
    document.body.style.overflow = ''; // Restore scrolling
  }
  
  // Event Listeners
  if (openSidebarBtn) {
    openSidebarBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      openDrawer();
    });
  } else {
    console.warn('Element with class .open-sidebar not found');
  }
  
  // Close drawer when clicking outside
  document.addEventListener('click', function(e) {
    if (html.classList.contains('sidebar-open')) {
      // Only if the drawer is open
      // Check if the click is outside the drawer
      if (drawer && !drawer.contains(e.target) && !openSidebarBtn.contains(e.target)) {
        closeDrawer();
      }
    }
  });

  closeIcon.addEventListener('click', function(e) {
    closeDrawer();
  });
  
  // Close drawer on escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      closeDrawer();
    }
  });
});